import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";

/**
 * Campos "richtext" do Strapi chegam como markdown. O estilo dos parágrafos vem
 * do container (ex.: `.institutional-intro p`), então não há renderers custom.
 */
export default function RichText({ source }) {
  if (!source) return null;
  return <ReactMarkdown source={source} />;
}

RichText.propTypes = {
  source: PropTypes.string,
};

/** Texto simples multilinha -> quebras de linha visuais. */
export function MultilineText({ text }) {
  const lines = (text || "").split("\n");
  return (
    <>
      {lines.map((line, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          {index > 0 && <br />}
          {line}
        </React.Fragment>
      ))}
    </>
  );
}

MultilineText.propTypes = {
  text: PropTypes.string,
};
